import styled from 'styled-components';
import {
  color,
  layout,
  minDesktopLarge,
  minDesktopRegular,
  minDesktopSmall,
  minDesktopXS,
  minTablet,
} from '../../GlobalStylesVisid';

export const CARDS_GAP = layout.size6;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${color.gray1};
  box-sizing: border-box;
  padding: 40px 16px 48px 16px;

  ${minTablet} {
    padding: 48px 32px 60px 32px;
  }
  ${minDesktopXS} {
    padding: 80px 32px 100px 32px;
  }
  ${minDesktopSmall} {
    padding: 80px 48px 100px 48px;
  }
  ${minDesktopRegular} {
    padding-left: calc((100% - 1440px) / 2);
    padding-right: calc((100% - 1440px) / 2);
  }
  ${minDesktopLarge} {
    padding-left: calc((100% - 1608px) / 2);
    padding-right: calc((100% - 1608px) / 2);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  width: 342px;
  row-gap: 24px;
  box-sizing: border-box;
  padding: 24px;
  color: ${color.gray7};

  ${minDesktopSmall} {
    width: 278px;
  }

  ${minDesktopRegular} {
    width: 342px;
  }

  ${minDesktopLarge} {
    width: 384px;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px 8px 0 0;
`;

export const ContainerTitle = styled.h1.attrs({ className: 'title-regular' })``;

export const CardTitle = styled.h3.attrs({ className: 'subtitle-large' })`
  color: ${color.gray12};
`;

export const CardDescription = styled.p.attrs({ className: 'body-regular' })``;

export const CardAnchor = styled.a.attrs({ className: 'body-regular' })``;

export const CardAction = styled.span.attrs({ className: 'body-regular' })`
  color: ${color.electricBlue7};
  cursor: pointer;
  text-decoration: underline;
`;
